import React from "react";
import { ANALYSIS_TYPE_OPTIONS } from "../constants";

const AnalysisTypeToggle = ({ value, onChange, disabled = false }) => (
  <div className="flex gap-0.5 self-start bg-gray-100 rounded-md p-0.5 no-drag">
    {ANALYSIS_TYPE_OPTIONS.map((option) => (
      <button
        key={option.id}
        type="button"
        onClick={() => onChange(option.id)}
        disabled={disabled}
        aria-pressed={value === option.id}
        className={`px-3 py-1.5 rounded text-sm font-medium whitespace-nowrap transition-colors disabled:opacity-60 ${
          value === option.id
            ? "bg-white text-primary-600 shadow-sm"
            : "text-gray-500 hover:text-gray-700"
        }`}
      >
        {option.label}
      </button>
    ))}
  </div>
);

export default AnalysisTypeToggle;
